import { RawMatchingID } from "models/dataRoom/matchingId";

export const matchingIdOptions: RawMatchingID[] = [
  RawMatchingID.STRING,
  RawMatchingID.EMAIL,
  RawMatchingID.HASHED_EMAIL,
  RawMatchingID.PHONE_NUMBER,
  RawMatchingID.HASHED_PHONE_NUMBER,
];
